<!-- src/components/index.vue -->
  
<template>
  <section id="subTitleFont">
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row justify-content-center align-items-center">
        <div class="col-3 d-flex flex-column align-items-center">
          <a v-if="user" ref="userLink" :href="`/profile/${user.profileurlName || '#'}`" class="text-decoration-none animate__animated d-flex align-items-center justify-content-center" @mouseenter="addTada" @mouseleave="removeTada">
            <img :src="user?.ProfilePicture" class="artist-avatar rounded-circle"> 
          </a>
          <a v-if="user" :href="`/profile/${user.profileurlName || '#'}`" class=" text-decoration-none textmain MainTitleFont">
            {{ user?.name || 'Anon' }}
          </a>
        </div>
        <div class="col-9">
          <h6 class="subTitleFont">Recent Posts</h6>
          <HomePagePart2ArtGallery v-if="user && user.id" :userId="user.id" :userSettings="userSettings" />
        </div>
      </div>
    </div>
  </section>
</template>
<style>
@media (max-width: 575.98px) {
    .artist-avatar {
      width: 75px;
      height: 75px;
      border-radius: 50%;
    }
}

/* For medium screens (between 576px and 767.98px) */
@media (min-width: 576px) and (max-width: 767.98px) {
.artist-avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
  }
}

/* For large screens (768px and above) */
@media (min-width: 768px) {
    .artist-avatar {
      width: 150px;
      height: 150px;
      border-radius: 50%;
    }
}
</style>
<script>

import 'bootstrap/dist/css/bootstrap.min.css';
import HomePagePart2ArtGallery from '@/HomePagePart2ArtGallery.vue';
import axios from 'axios';
import AOS from 'aos'; // Import AOS for animations
import 'aos/dist/aos.css'; // Import AOS styles
import 'animate.css';
export default {
  name: 'HomePagePart1ArtistsNews',
  props: ['id'], // Expecting user ID as a prop
  components: {
    HomePagePart2ArtGallery,
  },
  data() {
    return { 
      user: null,  // Will store the user data
      userSettings: null,  // Will store the user settings
    };
  },
  watch: {
    // Watch for changes in the id prop
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchUserData(newId);
        }
      }
    }
  },
  mounted() {
    // Initialize AOS for animations (if needed)
    AOS.init();
  },
  methods: {
    // Fetch user data from API
    fetchUserData(userId) {
      // Same server in production, the local API during npm run serve
      const base = process.env.NODE_ENV === 'production'
        ? ''
        : 'http://localhost:3002';
      
    // Use the new username/profileurlName endpoint
    axios.get(`${base}/api/user/${userId}`)
      .then(response => {
        console.log('API Response:', response.data);
        this.user = response.data;
        
        // Now fetch user settings using the numeric ID from the user data
        return axios.get(`${base}/api/userSettings/${this.user.id}`);
      })
      .then(response => {
        console.log('User Settings Response:', response.data);
        this.userSettings = response.data; // Store user settings
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
        this.user = null; // Reset user data on error
      });
    },
    // Toggle method for any property if you want to toggle something
    toggle(property) {
      this[property] = !this[property];
    },
    addTada() {
      if (this.$refs.userLink) {
        this.$refs.userLink.classList.add('animate__tada');
      }
    },
    removeTada() {
      if (this.$refs.userLink) {
        this.$refs.userLink.classList.remove('animate__tada');
      }
    },
  },
};

</script>
